import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { AdGroupsTable } from '../components/ad_groups/AdGroupsTable'
import { ExpandedPerformanceMetrics } from '../components/table2/ad_grid_columns'
import { TableStore } from '../components/table2/table_store'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import { AdGroup } from '../types/ad_group'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const AdGroups = observer(() => {
    const { profile } = useUser()
    const savedFiltersStore = useSavedFiltersStore()

    const [store] = useState<TableStore<AdGroup & ExpandedPerformanceMetrics>>(
        new TableStore(userStore, 'ad_groups'),
    )

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/ad-groups', params, true)
    }

    const tableHooks = useTableHooksFromStore(load, {}, false, store)

    return (
        <>
            <AdGroupsTable
                tableHooks={tableHooks}
                store={store}
                savedFiltersStore={savedFiltersStore}
            />
        </>
    )
})
